import axiosInstance from './axiosInstance'

interface CreateAccount {
  password: string
  email: string
  firstName: string
  lastName: string
  unitSystem: 'metric' | 'imperial'
  reminderNotification: boolean
  subscription: boolean
}

const login = (email, password) => {
  return axiosInstance.post(`/api/auth/admin-login-factor1`, {
    email,
    password,
  })
}

const loginUser = (email, password) => {
  return axiosInstance.post(`/api/auth/login-factor1`, {
    email,
    password,
  })
}

const createAccount = ({
  firstName,
  lastName,
  email,
  password,
  unitSystem,
  reminderNotification,
  subscription,
}: CreateAccount) => {
  return axiosInstance.post(`/api/auth/account-create`, {
    firstName,
    lastName,
    email,
    password,
    unitSystem,
    reminderNotification,
    subscription,
  })
}

const sendResetEmail = (email) => {
  return axiosInstance.post(`/api/auth/password-reset1`, { email })
}

const resetPassword = (email, password, code) => {
  return axiosInstance.post(`/api/auth/password-reset2`, {
    email,
    password,
    code,
  })
}

const validateResetCode = (code: string, email: string) => {
  return axiosInstance.post(`/api/auth/validate-reset-code`, {
    code,
    email,
  })
}

const logout = () => {
  return axiosInstance.post(`/api/auth/logout`, {})
}

const getUser = () => {
  return axiosInstance.get(`/api/user/me`)
}

const authApi = {
  login,
  createAccount,
  sendResetEmail,
  resetPassword,
  logout,
  validateResetCode,
  getUser,
  loginUser,
}

export default authApi
